import { createClient } from '@supabase/supabase-js';

const supabaseUrl = process.env.REACT_APP_SUPABASE_URL;
const supabaseAnonKey = process.env.REACT_APP_SUPABASE_ANON_KEY;

if (!supabaseUrl || !supabaseAnonKey) {
 console.error('Missing Supabase environment variables');
 console.error('REACT_APP_SUPABASE_URL:', supabaseUrl ? 'Set' : 'Missing');
 console.error('REACT_APP_SUPABASE_ANON_KEY:', supabaseAnonKey ? 'Set' : 'Missing');
}

// Create Supabase client with better error handling
export const supabase = createClient(
 supabaseUrl || '', 
 supabaseAnonKey || '',
 {
 auth: {
 persistSession: true,
 autoRefreshToken: true,
 },
 }
);

